import "./globals"
import "jquery-ujs"
import "bootstrap"
import "slick-carousel"
import "angular"
import "angular-resource"
import "./vendor/urlify"

import "./main"
import "./angular/config"
import "./angular/cart"
import "./angular/helpers/currency"
import "./angular/services/shoppingCart"
import "./products"
import "./static_pages"
